module.exports = __webpack_public_path__ + "img/ic_referral_detail_close.322d7a14.svg";